export default (obj = {}) =>
  Object
    .entries(obj)
    .map(([key, value]) => ({ key, value }))
